import React from 'react';
import store from '../../store/Store';
import actions from '../../actions/Actions';

import EditorPage from '../editorPage/EditorPage'
import Template from '../template/Template'

import { Redirect } from 'react-router-dom';

import SwipeableViews from 'react-swipeable-views'
import { bindKeyboard } from 'react-swipeable-views-utils'

import './editorContent.scss'

type editorContentState = {
	article: any;
	navigation: any;
}

type editorContentProps = {
	article: any;
	navigation: any;
}

const BindKeyboardSwipeableViews = bindKeyboard(SwipeableViews);

class EditorContent extends React.Component<editorContentState, editorContentProps> {

  constructor(props) {
  	super(props)

  	this.state = {
  		article: props.article,
  		navigation: props.navigation
  	}
  }

  componentDidMount() {
	store.subscribe(() => {
		this.setState({
			article: store.getState().article,
			navigation: store.getState().navigation
		})
	})
  }

  onChangeIndex = (selectedPage, lastPage) => {
  	actions.editorActions.setEditorSelectedPage(selectedPage)
  	actions.editorActions.setEditorPreviousPage(lastPage)
  }

  render() {
  	  const {
  	  	article,
  	  	navigation
  	  } = this.state

	  return (
	  	<div
	  		className="EditorContent"
	  		style={{
	  			width: '100vw',
	  			height: '100vh'
	  		}}
	  	>

			<BindKeyboardSwipeableViews 
	  			axis={ 'y' }
	  			enableMouseEvents 
	  			hysteresis={ 0.5 } 
	  			animateTransitions 
	  			animateHeight
	  			resistance={ false }
	  			ignoreNativeScroll= { true }
	  			onChangeIndex={ this.onChangeIndex.bind(this) }
	  			index={ article.info.currentPage }
	  		>

	  			{
	  				article.pages.map((page, index, array) => {
	  					return (
				  			<Template 
				  				key={ page.pageIndex }
				  				article={ article }
				  				navigation={ navigation }
				  			/>
	  					)
	  				})
	  			}

  			</BindKeyboardSwipeableViews>

	  		{
	  			store.getState().route.currentRoute === '/editorTemplate' ? (
                    <Redirect to='/editorTemplate' />
	  			) : (
	  				null
	  			)
	  		}

		</div>
	  );
	}
}

export default EditorContent;